// Shared predicate for whether a goal belongs on general goal surfaces
// (Goals page, dashboard widgets, analytics). Goals flagged with
// showOnMainGoalPage === false (e.g. fitness goals whose "Show on main
// Goals page" toggle is off) only appear on their source page.
export function isGoalVisibleOnMainSurfaces(goal: {
  showOnMainGoalPage?: boolean | null;
  isFutureGoal?: boolean | null;
  status?: string | null;
}): boolean {
  return goal.showOnMainGoalPage !== false &&
    goal.isFutureGoal !== true &&
    goal.status !== "future";
}

/** Future state is canonicalized defensively for legacy goals and form payloads. */
export function isFutureGoal(goal: { isFutureGoal?: boolean | null; status?: string | null }): boolean {
  return goal.isFutureGoal === true || goal.status === "future";
}
